// import * as CSV from './csv.min.js';
import { resolveComponent } from 'vue';
import * as dataStore from './data-store.js';
import * as dateUtils from './date-utils.js';
// import * as display from './display.js';
// import { parse }  from './csv-parse';
// import { parse } from '/ csv-parse/browser/esm/sync';

const googleMonthTabIds = ['26', '1558546627', '1215355158', '50696675', '180626928', '1111975697', '1839264645','349692664', '381313052', '1370359131', '295135307', '2029588053'];
const leaderboardTabId = '9';

const googleDocId2023 = '2PACX-1vT6K0omWc8tdnEj726NHLW54Ayi-NFPnOG_VHij3cJyKZOMkvqK-A8cWznevmZSbx8u_xt1N8pymcNu';
const googleDocId2024 = '2PACX-1vSsgKzq6tgKGAQZVuqof-BAUN1UtidLcovlUAJQkTvOXJUjd1gYtm1198vpZUCy5ivhFxrLxPJYEeG5';
const googleDocId2025 = '2PACX-1vS0swVilKGvvQNkSGq6sF874zNmqo4nh5BSUA2Qs4ahuB-hLtlCAB6m7lNDE7R6HqvClJ-FUJdxcN3O';
const googleDocId2026 = '2PACX-1vRQjJuQmdSTYz4XKxSANaqUMtwYVPEWn52vWX1CPNArJLwt4juNTASAISN7qXG9Nu5VSMSOj9Q7MH0M';

const googleDocIds = [googleDocId2023, googleDocId2024, googleDocId2025, googleDocId2026];
const startYear = 2023;

let appCallback = null;

export function setCallback(cb) {
  appCallback = cb;
}

export function getCallback() {
  return appCallback;
}

function getDocIdLeaderboard(year) {
  const yearDiff = year - startYear;
  const url = `https://docs.google.com/spreadsheets/d/e/${googleDocIds[yearDiff]}/pub?gid=${leaderboardTabId}&single=true&output=csv`;
  return url
}

function getGoogleDocId(year) {
  const yearDiff = year - startYear;
  return googleDocIds[yearDiff]
}

export async function showLeaderboard(year, screenWidth) {
  let maxCol = 0;
  let tableResults = document.getElementById('table-leaderboard');
  tableResults.innerHTML = '';
  let showLeaderboardColumns = [
    0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 25, 26, 27, 28,
  ];
  const monthColumns = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];
  const totalColumn = 25;
  // console.log('Showing Laderboard with width:', screenWidth);
  if (screenWidth < 600) {
    showLeaderboardColumns = [0, 25, 26, 27];
  }
  await dataStore.loadData(getDocIdLeaderboard(year)).then((data1) => {
    // console.log(data1);
    data1.forEach((row, rowIndex) => {
      let tr = tableResults.insertRow();
      // console.log(row);
      row.forEach((col, colIndex) => {
        // Only show people with points
        if (row[25] > 0 || rowIndex == 0) {
          // Add position column
          if (colIndex == 0) {
            if (rowIndex == 0) {
              tr.appendChild(document.createElement('th'));
            } else {
              tr.insertCell().innerHTML = rowIndex;
            }
          }
          if (rowIndex > 0 && monthColumns.includes(colIndex)) {
            if (col !== '' && colIndex > maxCol) {
              maxCol = colIndex;
            }
          }
          if (showLeaderboardColumns.includes(colIndex)) {
            if (rowIndex == 0) {
              let th = document.createElement('th');
              const monthNo = monthColumns.indexOf(colIndex);
              if (monthNo > -1) {
                th.className = 'month-result';
                col = col.substr(0, 3);
                th.innerHTML = `<span><abbr>${col}</abbr></span>`;
                th.onclick = () => {
                  this.getCallback().onMonthSelect(monthNo + 1);
                };
              } else {
                th.innerHTML = col;
              }
              tr.appendChild(th);
            } else {
              let td = tr.insertCell();
              td.innerHTML = col;
              if (colIndex == totalColumn) {
                td.className = 'total-points';
              }
              if (monthColumns.includes(colIndex)) {
                // td.className = 'month-result';
                if (row[colIndex - 1] == 'M') {
                  td.className = ' mentor';
                } else if (row[colIndex - 1] == 'TK') {
                  td.className = ' timekeeper';
                }
              }
              if (colIndex == 26 || colIndex == 27) {
                const typeCount = col;
                const iconType = colIndex == 26 ? 'fa-stopwatch' : 'fa-route';
                if (typeCount > 0) {
                  td.innerHTML = `<i class="fa ${iconType}"></i><span class="count">${typeCount}</span>`;
                } else {
                  td.innerHTML = '';
                }
              }
            }
          }
        }
      });
    });
    // Work out latest month that has values
  });
  return monthColumns.indexOf(maxCol) + 1;
}

// export function showMember(screenWidth) {
//   let tableResults = document.getElementById('test');
//   const showColumns = [0, 1];
//   dataStore.loadData(docIdTest).then((data1) => {
//     console.log(data1);
//     data1.forEach((row, rowIndex) => {
//       let tr = tableResults.insertRow();
//       // console.log(row);
//       row.forEach((col, colIndex) => {
//         if (rowIndex > 0) {
//           // Add position column
//           if (colIndex == 0) {
//             if (rowIndex == 0) {
//               tr.appendChild(document.createElement('th'));
//             } else {
//               tr.insertCell().innerHTML = rowIndex;
//             }
//           }
//           if (showColumns.includes(colIndex)) {
//             if (rowIndex == 0) {
//               let th = document.createElement('th');
//               th.innerHTML = col;
//               tr.appendChild(th);
//             } else {
//               let td = tr.insertCell();
//               td.innerHTML = col;
//             }
//           }
//         }
//       });
//     });
//   });
// }

export async function showMonth(year, monthNo, screenWidth) {
  document.getElementById('month-name').innerText =
    dateUtils.longmonth(monthNo);
  const showColumns = [0, 1, 6, 7, 8];
  let table2 = document.getElementById('table-month');
  table2.innerHTML = '';

  const docId = dataStore.googleTabUrl(googleMonthTabIds, getGoogleDocId(year), monthNo);
  await dataStore.loadData(docId).then((data1) => {
    // console.log(data1);
    data1.forEach((row, rowIndex) => {
      let tr = table2.insertRow();
      // console.log(row);
      row.forEach((col, colIndex) => {
        if (rowIndex > 0) {
          // Add position column
          // if (colIndex == 0) {
          //   if (rowIndex == 1) {
          //     tr.appendChild(document.createElement('th'));
          //   } else {
          //     tr.insertCell().innerHTML = rowIndex - 1;
          //   }
          // }
          if (showColumns.includes(colIndex)) {
            if (rowIndex == 1) {
              let th = document.createElement('th');
              th.innerHTML = col;
              tr.appendChild(th);
            } else {
              let td = tr.insertCell();
              if (colIndex == 6 && col == '') {
                col = 'DNF';
              }
              td.innerHTML = col;
              if (colIndex == 7 && col !== null) {
                if (col.includes('-')) {
                  td.className = 'time-neg';
                } else if (col !== '') {
                  td.className = 'time-pos';
                }
              }
            }
          }
        }
      });
    });
  });
  return true;
}
